import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import TitleScoreList from '@/components/TitleScoreList.vue';
import TitleCreditName from '@/components/details/TitleCreditName.vue';

import { SnowplowContext, SnowplowTitleContext } from '@/helpers/tracking/providers';
import { CreditRole } from '@/@types/graphql-types';
import { TitleDetail } from '@/interfaces/title-details-graphql';

import { formatRuntime } from '@/helpers/title-helper';
import { useI18n } from '@/helpers/composables/useI18n';
import { useLanguageStore, useRoutingStore, useUserStore } from '@/helpers/composables/useStores';
import { TrackingHelper } from '@/helpers/tracking/tracking-helper';

type RedundantSubgenre = keyof typeof subgenreToGenreDictionary;
type Subgenre = TitleDetail['content']['subgenres'][number]['content'] & {
	url: { fullPath: string };
};

export default /*#__PURE__*/_defineComponent({
  __name: 'TitleDetailTitleInfoV1',
  props: {
    title: null,
    additionalContexts: { default: () => [] },
    showRatingAndDirector: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { title: TitleDetail, additionalContexts: SnowplowContext[], showRatingAndDirector: boolean };



const { t } = useI18n();
const { urlMetadata } = useRoutingStore();
const { isPremium } = useUserStore();
const { country } = useLanguageStore();

const subgenreToGenreDictionary = {
	'Mystery Thriller': 'Mystery & Thriller',
	'Action Adventure': 'Action & Adventure',
};

const titleContent = computed(() => props.title.content);

const jwVotes = computed(() => {
	if (props.title.content.interactions?.votesNumber) {
		return props.title.content.interactions.votesNumber;
	} else {
		return null;
	}
});

const directors = computed(() => {
	const credits =
		props.title.__typename === 'Season' ? props.title.show.content.credits : props.title.content.credits;

	return credits.filter(credit => credit.role === CreditRole.Director);
});

const runtime = computed(() => {
	const runtimeValue = titleContent.value.runtime!;
	const { translationKey, minutes, hours } = formatRuntime(runtimeValue);

	return t(translationKey, { minutes, hours }) as string;
});

const htmlContent = computed(() => {
	return (urlMetadata.value && urlMetadata.value.html_content) || {};
});

const productionCountries = computed(() => {
	const titleContent = props.title.__typename === 'Season' ? props.title.show.content : props.title.content;

	return titleContent.productionCountries?.map(country => t(`WEBAPP_COUNTRY_${country}`)).join(', ');
});

const scoring = computed(() => {
	return titleContent.value.scoring;
});

const isReleased = computed(() => {
	return titleContent.value.isReleased;
});

//subgenres

const genres = computed(() => {
	const genresToRemove = new Set();
	subgenres.value.forEach(({ name }) => {
		if (subgenreToGenreDictionary[name as RedundantSubgenre] != null) {
			genresToRemove.add(subgenreToGenreDictionary[name as RedundantSubgenre]);
		}
	});

	return props.title.content.genres
		.map(genre => genre.translation)
		.filter(translation => !!translation && !genresToRemove.has(translation));
});

const showGenres = computed(() => {
	return genres.value.length > 0;
});

const subgenres = computed(() => {
	return props.title.content.subgenres.map(({ content }) => content).filter(el => el.url) as Subgenre[];
});

const showSubgenres = computed(() => {
	return country.value === 'US' && subgenres.value.length > 0;
});

function trackSubgenresClick(subgenre: string) {
	const seasonNumber = props.title.__typename === 'Season' ? props.title.content.seasonNumber : null;
	const contexts = (props.additionalContexts || []).concat([
		new SnowplowTitleContext(props.title.objectId, props.title.objectType, seasonNumber),
	]);

	TrackingHelper.trackEvent(
		'userinteraction',
		{
			action: 'subgenre_clicked',
			label: subgenre,
		},
		contexts
	);
	// trackTitleDetailRedesignNewBuyBoxExp({
	// 	action: 'click',
	// 	label: `subgenre_clicked`,
	// });
}
//

return { __sfc: true,props, t, urlMetadata, isPremium, country, subgenreToGenreDictionary, titleContent, jwVotes, directors, runtime, htmlContent, productionCountries, scoring, isReleased, genres, showGenres, subgenres, showSubgenres, trackSubgenresClick, TitleScoreList, TitleCreditName }
}

})